import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Terms() {
  return (
    <PageLayout
      title="Terms of Service"
      subtitle="The agreement governing your use of Paygent's payment infrastructure."
      badge="LEGAL"
    >
      <div className="prose prose-lg max-w-4xl mx-auto text-gray-600">
        <p className="text-sm text-gray-400 mb-8">Last updated: April 23, 2026</p>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
          <p>By accessing or using the Paygent platform, APIs, or any services provided by Wheelcall LLC ("Company"), you agree to be bound by these Terms of Service. If you are using Paygent on behalf of an organization, you represent that you have authority to bind that organization.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Service Description</h2>
          <p>Paygent provides payment processing infrastructure, including but not limited to: card-present and card-not-present transaction processing, recurring billing management, fraud detection, payout disbursement, and developer APIs. We act as a technology provider facilitating communication between merchants, acquiring banks, and card networks.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Merchant Obligations</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate business and beneficial ownership information during onboarding.</li>
            <li>Comply with all applicable card network rules (Visa, Mastercard, Discover, Amex).</li>
            <li>Maintain PCI DSS compliance appropriate to your integration method.</li>
            <li>Not use the platform for prohibited activities including illegal goods, unlicensed financial services, or transactions that violate OFAC sanctions.</li>
            <li>Respond to chargebacks and disputes within the required timeframes.</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Fees & Billing</h2>
          <p>Transaction fees, monthly platform fees, and any applicable charges are outlined on your merchant agreement and/or the Pricing page. We reserve the right to modify pricing with 30 days written notice. All fees are non-refundable unless otherwise stated.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Reserve & Holdback Rights</h2>
          <p>Paygent reserves the right to establish rolling reserves, holdback percentages, or delayed settlement schedules based on risk assessment. These measures protect against chargebacks, fraud losses, and regulatory exposure.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Intellectual Property</h2>
          <p>All Paygent branding, documentation, APIs, SDKs, and proprietary technology remain the exclusive property of Wheelcall LLC. You are granted a limited, non-exclusive, revocable license to use our APIs solely for the purpose of integrating payment processing into your application.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Wheelcall LLC shall not be liable for indirect, incidental, special, consequential, or punitive damages arising from your use of the platform. Our total liability shall not exceed the fees paid by you in the 12 months preceding the claim.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Termination</h2>
          <p>Either party may terminate this agreement with 30 days written notice. We may suspend or terminate your account immediately if we detect fraud, violations of card network rules, or illegal activity. Upon termination, outstanding balances will be settled according to the standard payout schedule.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Governing Law</h2>
          <p>These terms are governed by the laws of the State of Georgia, United States. Any disputes shall be resolved through binding arbitration in Fulton County, GA.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact</h2>
          <p>For questions about these terms, contact <a href="mailto:legal@gopaygent.com" className="text-blue-600 hover:underline">legal@gopaygent.com</a>.</p>
        </section>
      </div>
    </PageLayout>
  );
}
